module.exports = __webpack_public_path__ + "img/car-mask-3.07304080.png";